// src/components/phase05/progressNotes/ProgressNotePrint.jsx
import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchProgressNote } from "../../../store/slices/progressNotesSlice";
import logo from "../../../assets/images/logo-samplee.png";

export default function ProgressNotePrint() {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { currentProgressNote, isLoading, error } = useSelector(
    (state) => state.progressNotes || {}
  );

  useEffect(() => {
    if (id) dispatch(fetchProgressNote(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (currentProgressNote) {
      const timer = setTimeout(() => window.print(), 600);
      window.onafterprint = () => navigate(-1);
      return () => {
        clearTimeout(timer);
        window.onafterprint = null;
      };
    }
  }, [currentProgressNote, navigate]);

  if (isLoading) return <div className="p-8 text-center">Loading…</div>;
  if (error) return <div className="p-8 text-danger text-center">{error}</div>;
  if (!currentProgressNote) return <div className="p-8 text-center">No record found.</div>;

  const d = currentProgressNote;
  const notes = d.details || [];

  const formatDateTime = (dateStr) => {
    if (!dateStr) return "";

    // Convert "YYYY-MM-DD HH:mm:ss" → "YYYY-MM-DDTHH:mm:ss"
    const safeDate = new Date(dateStr.replace(" ", "T"));

    return safeDate.toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true, // 👈 This gives AM/PM
    });
  };

  // We show: all real notes + blank ones to make total 6 (standard progress note page)
  const totalSlots = 6;
  // const filledNotes = notes.length;
  const blankNotes = totalSlots - notes.length;

  return (
    <>
      <style jsx global>{`
        * { margin: 0 !important; padding: 0 !important; box-sizing: border-box !important; }
        body { font-family: Arial, sans-serif !important; background: #fff !important; color: #000 !important; }

        .print-container {
          padding: 20px !important;
          position: relative !important;
        }

        .logo {
          position: absolute !important;
          top: 10px !important;
          left: 10px !important;
          z-index: 1000 !important;
        }
        .logo img { height: 60px !important; width: auto !important; }

        .header h3 {
          font-size: 1.5em !important;
          font-weight: bold !important;
          text-align: center !important;
          border-bottom: 1.5px solid #383838 !important;
          padding-bottom: 15px !important;
          margin-bottom: 10px !important;
          color: #000000 !important;
        }

        
        .header h6 {
          font-size: 1.2em !important;
          text-align: center !important;
          margin-bottom: 5px !important;
          font-weight: semibold !important;
          color: #000000 !important;
        }

        .client-info {
          display: flex !important;
          justify-content: space-between !important;
          margin-bottom: 14px !important;
          font-size: 1rem !important;
        }

        .underline {
          border-bottom: 1px solid #000 !important;
          display: inline-block !important;
          width: auto !important;
          margin-left: 8px !important;
          padding: 0 4px !important;
          font-weight: bold !important;
        }

        .note-block {
          margin-bottom: 38px !important;
          page-break-inside: avoid !important;
        }
        .note-date {
          font-weight: bold !important;
          font-size: 1.02em !important;
          margin-bottom: 8px !important;
        }
        .note-box {
          border: 1.5px solid #000 !important;
          padding: 14px !important;
          min-height: 80px !important;
          font-size: 0.98em !important;
          line-height: 1.7 !important;
          background-color: #fbfbfb !important;
        }

        .footer {
          margin-top: 50px !important;
          border-top: 1.5px solid #000 !important;
          padding-top: 12px !important;
          text-align: center !important;
          font-size: 1em !important;
        }
        .footer p {
          margin-bottom: 7px !important;
        }

        @media print {
          .print-container { padding: 15px !important; }
        }
      `}</style>

      <div className="logo">
        <img src={logo} alt="The Recovery House" />
      </div>

      <div className="print-container">
        {/* Header */}
        <div className="header">
          <h3>THE RECOVERY HOUSE</h3>
          <h6>PROGRESS NOTE</h6>
        </div>

        {/* Progress Notes - Dynamic + Blank Filler */}
        {notes.map((note) => (
          <div key={note.id} className="note-block">
            <div className="note-date">Date: {formatDateTime (note.note_date)}</div>
            <div className="note-box">{note.progress_note || ""}</div>
          </div>
        ))}

        {/* Footer */}
        <div className="footer">
          <p>156 Bangalore Town, Tipu Sultan Road Karachi-Pakistan</p>
          <p>Ph : 021-34546364-65-66</p>
          <p><strong>A Project of “CARVAN OF LIFE PAKISTAN TRUST”</strong></p>
        </div>
      </div>
    </>
  );
}